export default "__VITE_ASSET__DAlJLrGl__"